import PageLayout from "../../../Components/LayoutContainers/PageLayout";
import MDBox from "../../../Components/MDBox";
import {Grid} from "@mui/material";


function BasicLayout({
                         image,
                         children,
                     }) {
    return (
        <PageLayout>
            <MDBox
                position="absolute"
                width="100%"
                minHeight="100vh"
                bottom="0"
                sx={{
                    backgroundColor: "#D7F4FC",
                    backgroundImage: ({
                                          functions: {linearGradient, rgba},
                                          palette: {gradients},
                                      }) =>
                        image &&
                        `${linearGradient(
                            rgba(gradients.dark.main, 0),
                            rgba(gradients.dark.state, 0)
                        )}, url(${image})`,
                    backgroundSize: "50% 50%",
                    filter: "blur(0px)",
                    backgroundPosition: "bottom center",
                    backgroundRepeat: "no-repeat",
                }}
            />
            <MDBox width="100%" height="100vh" mx="auto">
                {children}

            </MDBox>
        </PageLayout>
    );
}


export default BasicLayout;
